import { render, staticRenderFns } from "./Stock-transfer.vue?vue&type=template&id=007dda10&scoped=true"
import script from "./Stock-transfer.vue?vue&type=script&lang=js"
export * from "./Stock-transfer.vue?vue&type=script&lang=js"
import style0 from "./Stock-transfer.vue?vue&type=style&index=0&id=007dda10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007dda10",
  null
  
)

export default component.exports